module.exports = __webpack_public_path__ + "img/Who-We-Are-Section-1-BG.4fa46be6.jpg";